import { Controller } from 'stimulus';
import Rails from '@rails/ujs';
import Sortable from 'sortablejs';

export default class extends Controller {
  connect() {
    if (this.isMobileDevice()) return;

    this.sortable = Sortable.create(this.element, {
      onEnd: this.updatePosition.bind(this),
      filter: '.no-drag',
      animation: 150,
    });
  }

  updatePosition(event) {
    if (!event.item.dataset.url) return;

    const data = new FormData();
    data.append('position', event.newIndex + 1);

    // Store for potential rollback
    const oldIndex = event.oldIndex;
    const newIndex = event.newIndex;
    const item = event.item;

    Rails.ajax({
      url: event.item.dataset.url,
      type: 'PATCH',
      data,
      success: (response) => {
        console.log('Position updated successfully');
      },
      error: (error) => {
        console.error('Position update failed:', error);

        // Rollback visual change
        if (oldIndex < newIndex) {
          this.element.insertBefore(item, this.element.children[oldIndex]);
        } else {
          this.element.insertBefore(item, this.element.children[oldIndex + 1]);
        }

        // User notification
        this.showError('Failed to update order. Please try again.');
      }
    });
  }

  showError(message) {
    // Use browser alert for now - replace with your app's notification system if available
    alert(message);
  }

  isMobileDevice() {
    return (
      (navigator.userAgentData && navigator.userAgentData.mobile) ||
      /Mobile|webOS|iPhone|iPad|iPod/i.test(navigator.userAgent) ||
      window.matchMedia('(pointer:coarse)').matches
    );
  }

  disconnect() {
    if (this.sortable) {
      this.sortable.destroy();
    }
  }
}
